import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => `${props.theme.spacing.sp8} ${props.theme.spacing.sp16}`};
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: ${props => props.theme.primitives.radius.radius1};
`
